import { render, staticRenderFns } from "./MenusMainCard.vue?vue&type=template&id=525dea64&"
import script from "./MenusMainCard.vue?vue&type=script&lang=js&"
export * from "./MenusMainCard.vue?vue&type=script&lang=js&"
import style0 from "./MenusMainCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports